<!-- <div class="row">
  <div class="col">
    <button type="button" class="updatebtn"
                style="float: right;width: auto;"(click)="update_doc()">
                <p style="margin: 0 25px;">
                    Actualizar
                </p>
            </button>
  </div>
</div> -->

<nav>
  <div class="nav nav-tabs" id="nav-tab" role="tablist">
    <a class="nav-item nav-link active" id="nav-exm-tab" data-toggle="tab" href="#nav-exm" role="tab" aria-controls="nav-exm" aria-selected="true">Diagnostico e indicaciones</a>
    <a class="nav-item nav-link" id="nav-odc-tab" data-toggle="tab" href="#nav-odc" role="tab" aria-controls="nav-odc" aria-selected="false">Mis órdenes de exámenes</a>
    <a class="nav-item nav-link" id="nav-rcm-tab" data-toggle="tab" href="#nav-rcm" role="tab" aria-controls="nav-rcm" aria-selected="false">Mis recetas médicas</a>
    <a class="nav-item nav-link" id="nav-exa-tab" data-toggle="tab" href="#nav-exa" role="tab" aria-controls="nav-exa" aria-selected="false">Mis certificados médicos</a>
    <a class="nav-item nav-link" id="nav-bol-tab" data-toggle="tab" href="#nav-bol" role="tab" aria-controls="nav-bol" aria-selected="false">Boletas</a>
    <a class="nav-item nav-link" id="nav-otros-tab" data-toggle="tab" href="#nav-otros" role="tab" aria-controls="nav-otros" aria-selected="false">Otros documentos</a>
    <a class="nav-item nav-link" id="nav-mascota-tab" data-toggle="tab" href="#nav-mascota" role="tab" aria-controls="nav-mascota" aria-selected="false">Mascotas</a>

  </div>
</nav>

<div class="tab-content" id="nav-tabContent">

  <div class="tab-pane fade show active" id="nav-exm" role="tabpanel" aria-labelledby="nav-exm-tab">
    <br>
    <div class="row">

      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.diagnosticos" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Generado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, item.app_boo_id, 'diagnostico')"
              class="card-btn d-flex"> <mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="tab-pane fade" id="nav-otros" role="tabpanel" aria-labelledby="nav-otros-tab"><br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.otros" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Adjuntado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, null, 'otros')"
              class="card-btn d-flex"> <mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tab-pane fade" id="nav-mascota" role="tabpanel" aria-labelledby="nav-mascota-tab"><br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.docsMascotas" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Adjuntado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, null, 'mascota')"
              class="card-btn d-flex"> <mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade" id="nav-bol" role="tabpanel" aria-labelledby="nav-bol-tab"><br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.boletas" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Generado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, null, 'boleta')"
              class="card-btn d-flex"> <mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade" id="nav-exa" role="tabpanel" aria-labelledby="nav-exa-tab"><br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.certificados" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Generado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, item.app_boo_id, 'certificado')"
              class="card-btn d-flex"><mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade" id="nav-odc" role="tabpanel" aria-labelledby="nav-odc-tab">
    <br>

    <div class="row" style=" display: flex; justify-content: flex-end;">
      <div class="mb-3 d-flex justify-content-start" style=" padding-right: 15px; padding-left: 15px;">
        <button
          *ngIf="pageInfo.cus_can_examedi"
          type="button"
          class="examedi-card__action"
          style="font-size: 18px; padding: 10px 15px; color: white; background-color: #316AD8; border: none; border-radius: 10px; font-family: 'Mulish'; font-weight: 500;"
          (click)="openExamedi()">
          <span style="display: flex; align-items: center; gap: 10px;">
            <img src="assets/images/icon/examedi-icon.png">
            Cotiza exámenes a domicilio con EXAMEDI
          </span>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.examenes" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{item.file_name_desc}}</h4>
            </div>
            <p class="card-text">Generado el: {{item.att_date| date:'dd/MM/yyyy'}}</p>
            <button
              (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, item.app_boo_id, 'examen', item.med_ord_is_digital_pad)"
              class="card-btn d-flex"><mat-icon>file_download</mat-icon> Descargar documento</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade" id="nav-rcm" role="tabpanel" aria-labelledby="nav-rcm-tab"><br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6" *ngFor="let item of documentos.recetas" ngModel ngDefaultControl>
        <div class="card">
          <div class="card-body">
            <div class="dropdown dots">
              <h4 class="card-title">{{ item.file_name_desc }}</h4>
            </div>

            <p class="card-text">Generado el: {{ item.att_date | date:'dd/MM/yyyy' }}</p>

            <div class="card-actions">
              <button
                (click)="_general.descargarFileAtt(item.att_id, item.file_name_desc,null, null, null, item.app_boo_id, 'receta', item.pre_is_digital_pad)"
                class="card-btn d-flex"><mat-icon>file_download</mat-icon>Descargar receta medica</button>
              <button *ngIf="item.pre_pdf_yapp" type="button"
                class="card-btn card-btn-yapp d-flex align-items-center justify-content-center"
                (click)="openYappModal(item.pre_pdf_yapp)">
                <mat-icon>attach_money</mat-icon>
                Algunas cotizaciones de medicamentos
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal-backdrop fade show"></div> -->
  <div class="modal modal-backdrop fade show" id="modalYappPdf" tabindex="-1" role="dialog"
    aria-labelledby="modalYappPdfLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-yapp" role="document">
      <div class="modal-content modal-yapp-content">
        <div class="modal-body modal-yapp-body">

          <h2 class="modal-yapp-title">¿Deseas acceder a algunas referencias de precios de tus medicamentos?</h2>

          <p class="modal-yapp-text">
            Al seleccionar esta opción, serás redirigido al detalle de cotización generada por YAPP, donde podrás
            revisar el detalle de algunos o todos los medicamentos recetados, sus precios y su disponibilidad en
            farmacias cercanas. </p>
          <div class="modal-yapp-info-box">
            <div class="modal-yapp-info-icon">
              <mat-icon>info</mat-icon>
            </div>
            <div class="modal-yapp-info-text">
              Al hacer esto no estamos entregando tu información personal. 
              <br>
              Estamos generando un listado de  precios referenciales de medicamentos en base a tu comuna de acuerdo a lo recetado por el profesional.
            </div>
          </div>
          <div class="modal-yapp-actions">
            <button type="button" class="btn-yapp-cancel" data-dismiss="modal">
              Cancelar
            </button>
            <button type="button" class="btn-yapp-accept" (click)="confirmOpenYappPdf()">
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="tab-content nav-tabs">
 
  <div id="menu3" class="tab-pane fade">
    <br>

  </div>
</div>

  <div class="tab-content nav-tabs">

    <div id="menu3" class="tab-pane fade">
      <br>

    </div>
  </div>
